import OpenBidCards from './OpenBidCards';

export default OpenBidCards;
